export enum NotificationType {
  AutoMuteLargeRoom = 'autoMuteLargeRoom',
  ParticipantJoined = 'participantJoined',
  HandRaised = 'handRaised',
  ParticipantMuted = 'participantMuted',
  MessageReceived = 'messageReceived',
  LowerHand = 'lowerHand',
  ReactionReceived = 'reactionReceived',
  ParticipantWaiting = 'participantWaiting',
  TranscriptionStarted = 'transcriptionStarted',
  TranscriptionStopped = 'transcriptionStopped',
  TranscriptionLimitReached = 'transcriptionLimitReached',
  TranscriptionRequested = 'transcriptionRequested',
  ScreenRecordingStarted = 'screenRecordingStarted',
  ScreenRecordingStopped = 'screenRecordingStopped',
  ScreenRecordingRequested = 'screenRecordingRequested',
  ScreenRecordingLimitReached = 'screenRecordingLimitReached',
  RecordingSaving = 'recordingSaving',
  PermissionsRemoved = 'permissionsRemoved',
  RoleChanged = 'roleChanged',
}
